
<template>
  <div>
    <router-view v-if="isJobImport" />
    <div v-else>
      <CRow>
        <CCol sm="12">
            <CCard class='tablewrapper'>
              <CCardHeader>
                <CIcon name="cil-grid"/> インポート管理
                <div v-if="!isNotPermitted" class="card-header-actions ml-3">
                  <CButton color="info" square type="file" @click="triggerButtonUpload()">Upload Sample</CButton>
                  <input type="file" ref="fileUpload" class="d-none" @change="onFileChange"/>
                </div>
                <div class="card-header-actions ml-2">
                  <CButton color="primary" class="btn-pil" :disabled="!canImport" :title="canImport ? '' : '法人を選択すると有効になります'" @click="goJobImport">
                    <i class="fa fa-upload button-icon me-2"></i> 求人票インポート
                  </CButton>
                </div>
              </CCardHeader>
              <CCardBody>
                <div class="d-flex justify-content-between align-items-center mb-3 mx-0">
                  <div class="ml-0 ml-md-3 flex-shrink-0">
                    <CButtonGroup class="rounded-lg overflow-hidden border header-toggle">
                      <CButton :color="viewMode === 'company' ? 'primary' : 'light'"
                              class="rounded-0 px-3 toggle-btn"
                              @click="switchView('company')">法人</CButton>
                      <CButton :color="viewMode === 'school' ? 'primary' : 'light'"
                              class="rounded-0 px-3 toggle-btn"
                              @click="switchView('school')">学校</CButton>
                    </CButtonGroup>
                  </div>
                  <div class="form-inline p-0">
                    <label class="mr-2">Filter:</label>
                    <input type="text" class="form-control" v-model="searchInfo.keyword">
                  </div>
                  <div class="d-flex align-items-center ml-3">
                    <span class="mr-2 mb-0">解析不可のみ</span>
                    <CSwitch
                      v-bind="{ variant: '3d', shape: 'pill' }"
                      color="primary"
                      :checked.sync="isNotParseable"
                      class="ml-2"
                    />
                  </div>
                  <div class="form-inline p-0">
                    <label class="mr-2">インポート状況:</label>
                    <CSelect :options="statusOption" :value.sync="searchInfo.status" placeholder="Select Status"/>
                  </div>
                </div>
                <CDataTable
                  :hover="true"
                  :striped="true"
                  :items="items"
                  :loading="isLoading"
                  :fields="fields"
                  :itemsPerPage="20"
                  class='table-scroll'
                >

                  <template #created_at="{item}">
                    <td class="text-center">{{ formatDate(item.created_at) }}</td>
                  </template>
                  <template #state="{item}">
                    <td class="text-center">{{ stateDict[item.state] }}</td>
                  </template>
                  <template #job_type="{item}">
                    <td class="text-center">{{ jobTypeDict[item.job_type] }}</td>
                  </template>

                  <template #fix="{item}">
                    <td class="text-center">
                      {{ item.manage_status.fix ?? 0 }}
                    </td>
                  </template>

                  <template #auto_fix="{item}">
                    <td class="text-center">
                      {{ item.manage_status.auto_fix ?? 0  }}
                    </td>
                  </template>

                  <template #not_fix="{item}">
                    <td class="text-center">
                      {{ item.manage_status.not_fix ?? 0  }}
                    </td>
                  </template>

                  <template #not_parseable="{item}">
                    <td class="text-center">
                      {{ item.manage_status.not_parseable ?? 0  }}
                    </td>
                  </template>

                  <template #show_details="{item, index}">
                    <td class="py-2">
                      <CButton v-if="!isNotPermitted" class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                      <router-link  class="slide-item" :to="'/tasks/' + item.id">
                        <CButton  color="danger" variant="outline" square size="sm">処理する</CButton>
                      </router-link>
                    </td>
                  </template>
                </CDataTable>

              </CCardBody>
            </CCard>
        </CCol>
        <CCol sm="12" class="text-center">
          <paginate
            v-model="page"
            :page-count="meta.total_pages"
            :prev-text="'前へ'"
            :next-text="'次へ'"
            :click-handler="paging"
            :container-class="'pagination'">
          </paginate>
        </CCol>
      </CRow>
      <CModal
        title="インポート状況の編集"
        color="secondary"
        :show.sync="recordModal"
      >
        <CRow class="form-box">
          <CCol sm="12">
            <label class="record-label pt-3">インポート状況</label>
            <CSelect
              placeholder="インポートステータスを選択してください"
              :options="schoolTypes"
              :value.sync="record.state"
            />
          </CCol>
          <CCol sm="12" v-if="record.state == 'failed'">
            <label class="record-label pt-3">要確認の理由</label>
            <CTextarea placeholder="" v-model="record.message" rows="7"/>
          </CCol>
        </CRow>

        <template #footer>
          <CButton size="sm" color="secondary" @click="hideUploadFileModal()">キャンセル</CButton>
          <CButton size="sm" color="info" @click="updateItem(itemIndex)">更新</CButton>
          <CButton v-if="record.need_to_rerun" size="sm" color="danger" @click="reRunItem()">再インポート</CButton>
        </template>
      </CModal>

      <CModal
        title="法人データCSVインポート"
        color="secondary"
        :show.sync="confirmUploadFileModal"
      >
        <CRow class="form-box">
          <CCol sm="12">
            <label class="record-label pt-3">インポートを実行してもよろしいですか？</label>
          </CCol>

        </CRow>

        <template #footer>
          <CButton size="sm" @click="hideUploadFileModal()">キャンセル</CButton>
          <CButton size="sm" color="info" @click="uploadFile">実行</CButton>
        </template>
      </CModal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex';
import Paginate from 'vuejs-paginate';

export default {
  name: 'Home',
  components: { Paginate },
  data() {
    return {
      viewMode: 'company',
      isLoading: false,
      mode: 'Create',
      recordModal: false,
      deleteModal: false,
      confirmUploadFileModal:false,
      itemIndex: 0,
      record: {},
      items: [],
      filter_cs: [],
      filter_vs: [],
      industryTypes: [],
      page: 1,
      word: "",
      meta: {
        total_pages: 0
      },
      industries: {},
      isNotParseable: false,
      jobs: {},
      jobTypeDict: {
        "public": "公開求人",
        "designated": "指定校求人"
      },
      stateDict: {
        "running": "解析中",
        "review": "解析中(最終確認)",
        "completed": "完了",
        "failed": "要確認"
      },
      schoolTypes: [
         {
            label: "解析中",
            value: "running",
         },
         {
            label: "解析中(最終確認)",
            value: "review",
         },
         {
            label: "完了",
            value: "completed"
         },
         {
            label: "要確認",
            value: "failed"
         }
      ],
      memberDic: {"associate_member": "仮登録", "no_deposite_member": "本登録(未入金)", "member": "本登録"},
      importFile: undefined,
      searchKeyWord: "",
      isSearching: false,
      searchInfo: {
        keyword: "",
        status: "",
      },
      statusOption: [{
        label: "All",
        value: ""
      }]
    }
  },
  watch: {
    searchInfo: { handler(newVal){ this.search(newVal) }, deep: true },
    isNotParseable: { handler(newVal){ this.search(newVal) }, deep: true },

    isJobImport(newVal, oldVal) {
      if (!newVal && oldVal) {
        // 戻ってきたので現在の検索条件で再取得
        const { status, keyword } = this.searchInfo
        this.page = 1
        this.getTaskQueues(status, keyword, 1)
      }
    },
  },
  methods: {
    formatIndustry: function(d) {
      //var s = ""
      //d.split(",").forEach(i => {
      //  s += this.industries[i] + ","
      //})
      return d
    },
    updateItem: function(index=0) {
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/task_queues/" + this.record.id, {"task": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then((response) => {
          this.recordModal = false
          this.record = response.data
          this.$set(this.items, index, JSON.parse(JSON.stringify(this.record)))
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
    reRunItem: function() {
      axios
        .post(`${process.env.VUE_APP_API_ENDPOINT}/api/mng/task_queues/${this.record.id}/rerun`,
          null,
          {headers: {'Authorization': 'Bearer ' + this.idToken}}
        )
        .then(() => {
          this.recordModal = false
          this.items.forEach((item) => {
            if(item.id === this.record.id) {
              item.state = "running"
              item.need_to_rerun = false
              item.message = ""
            }
          })
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
    formatDate: function(d) {
        return moment(d).format("YYYY/MM/DD HH:mm")
    },
    showRecordModal: function(i, index) {
      this.recordModal = true
      this.record = i
      this.itemIndex = index
      this.record = JSON.parse(JSON.stringify(i))
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    showUploadFileModal: function() {
      this.confirmUploadFileModal = true
    },
    hideUploadFileModal: function() {
      this.confirmUploadFileModal = false
      this.recordModal = false
    },
    triggerButtonUpload: function() {
      this.importFile = undefined
      this.$refs.fileUpload.click()
    },
    onFileChange() {
      this.importFile = this.$refs.fileUpload.files[0]
      this.showUploadFileModal();
    },
    uploadFile() {
      const formData = new FormData()
      formData.append('file', this.importFile)
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/import_reference_data", formData, {headers: {'Authorization': 'Bearer ' + this.idToken, 'Content-Type': 'multipart/form-data'}})
        .then(response => {
          if(response.status == 200) {
            Swal.fire({
              title: 'Success!',
              icon: 'success',
              confirmButtonText: 'Ok'
            })
            this.hideUploadFileModal()
            this.$refs.fileUpload.value = null;
            this.importFile = undefined
          }
        }).catch(error => {
          Swal.fire({
            title: 'Error!',
            text: error,
            icon: 'error',
            confirmButtonText: 'Ok'
          })
          this.hideUploadFileModal()
          this.$refs.fileUpload.value = null;
          this.importFile = undefined
        })
    },
    buildParams(status = "", word = "", current_page = 1) {
      return {
        status: status || "",
        key_word: word || "",
        not_parseable: this.isNotParseable ? true : false,
        scope: this.viewMode,
        per_page: 50,
        page: current_page
      }
    },
    paging(pageNum) {
      this.getTaskQueues(this.searchInfo.status, this.searchInfo.keyword, pageNum)
    },
    getTaskQueues(status = "", word = "", current_page = 1) {
      const url = `${process.env.VUE_APP_API_ENDPOINT}/api/mng/task_queues`
      axios.get(url, {
        params: this.buildParams(status, word, current_page),
        headers: { Authorization: 'Bearer ' + this.idToken }
      })
      .then((response) => {
        const listId = response.data.tasks.map(t => t.id)
        this.items = response.data.tasks
        this.meta.total_pages = response.data.meta.total_pages
        localStorage.setItem('task_list_id', listId)
      })
      .catch(err => this.errorNotify(err.response))
    },
    search(searchInfo) {
      if (searchInfo.keyword !== "" || searchInfo.status !== "") {
        this.isSearching = true
        this.word = (searchInfo.keyword === "-") ? "" : searchInfo.keyword
        this.$store.commit('setStatusSearch', searchInfo.status)
        this.page = 1
        this.getTaskQueues(searchInfo.status, this.word, 1)
      } else {
        this.isSearching = false
        this.page = 1
        this.getTaskQueues("", "", 1)
      }
    },
    switchView(mode) {
      if (this.viewMode === mode) return
      this.viewMode = mode
      this.page = 1
      this.getTaskQueues(this.searchInfo.status, this.searchInfo.keyword, 1)
    },
    goJobImport() {
      if (!this.canImport) return;
      this.$router.push({ name: 'JobImport' });
    },
  },
  computed: {
    isJobImport() {
      return this.$route.name === 'JobImport'
    },
    ...mapGetters({
      statusSearch:'GetStatusSearch',
      idToken:'GetIdToken',
      role: 'GetRole',
    }),
    isNotPermitted() {
      return this.role == 'member'
    },
    canImport() { return this.viewMode === 'company' },
    fields() {
      const nameLabel = this.viewMode === 'company' ? '法人名' : '学校名';
      return [
        { key: 'id', label: "インポートID"},
        { key: 'created_at', label: "インポート日時"},
        { key: 'name', label: nameLabel },
        { key: 'state', label: "インポート状況"},
        { key: 'job_type', label: "求人区分"},
        { key: 'total_job', label: "読み込み求人票数"},
        { key: 'already_job', label: "登録済により自動削除された求人票数"},
        { key: 'fix', label: "修正済"},
        { key: 'auto_fix', label: "反映済"},
        { key: 'not_fix', label: "未修正"},
        { key: 'not_parseable', label: "解析不可"},
        { key: 'show_details', label: '',  _style: 'width:15%', sorter: false, filter: false},
      ]
    }
  },
  mounted() {
    this.searchInfo.status = this.statusSearch
    this.getTaskQueues(this.statusSearch)
    this.statusOption = [...this.statusOption, ...this.schoolTypes]
  }
}
</script>
<style scoped>
.tablewrapper{
  overflow-x: scroll;
}
.table-scroll{
  border-collapse: collapse;
  white-space: nowrap;
}
.red{
  color: red
}
.inline-flex > .btn {
  border-radius: 0 !important;
}
.header-toggle .btn:focus,
.header-toggle .btn:active {
  outline: none !important;
  box-shadow: none !important;
}
.btn[disabled],
button[disabled],
.c-btn[disabled] {
  cursor: not-allowed;
  opacity: .65;
}
</style>
